import {
  getHireLocationsDirectHirePreviewRetrieveQueryOptions,
  getProContractorTypeListQueryOptions,
  getSkillsListQueryOptions,
} from "@sidegigllc/api/client";

type PreviewInput = { locationId: number; proId: number; positionId: number | undefined };

// refetchOnWindowFocus is off for the two option lists: refetching could reshuffle the selects mid-edit.
export const positionsQuery = () =>
  getSkillsListQueryOptions(
    { license: "hire", include_defaults: true, query: "ordered_by_popularity" },
    { query: { refetchOnWindowFocus: false } },
  );

export const jobTypesQuery = () =>
  getProContractorTypeListQueryOptions({ license: "hire" }, { query: { refetchOnWindowFocus: false } });

/** Default wage and booked shifts for a Pro in a position; only fetched once a position is picked. */
export const directHirePreviewQuery = ({ locationId, proId, positionId }: PreviewInput) => ({
  ...getHireLocationsDirectHirePreviewRetrieveQueryOptions(locationId, { pro_id: proId, position_id: positionId }),
  enabled: !!positionId,
});
